import { FC, useRef } from 'react'
import {
  ITestContentMatchWordsWithImages,
  ITestImageMatching
} from 'shared/types'
import { VStack, Button } from '@chakra-ui/react'
import { generateId } from 'controllers/db'
import _ from 'lodash'
import EditTestMatchWithImagesRow from 'components/sections/editSectionTestMatchWithImages/EditTestMatchWithImagesRow'

type Props = {
  test: ITestContentMatchWordsWithImages
  onChange: (test: ITestContentMatchWordsWithImages) => void
}

const MAX_ROWS = 8

const EditTestMatchWithImages: FC<Props> = ({ test, onChange }) => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  const handleAddRow = () => {
    const newMatching = [
      ...(test.matching || []),
      { id: generateId(), word: '', imageUrl: '' }
    ]
    onChange({ ...test, matching: newMatching })
  }

  const onChangeRow = (item: ITestImageMatching) => {
    const newMatching = _.map(test.matching, (m) => {
      if (m.id === item.id) {
        return item
      }
      return m
    })
    onChange({ ...test, matching: newMatching })
  }

  const onDeleteRow = (id: string) => {
    const newMatching = _.filter(test.matching, (m) => m.id !== id)
    onChange({ ...test, matching: newMatching })
  }

  return (
    <VStack w='full' spacing={6} ref={containerRef}>
      {_.map(test.matching, (item, index) => (
        <EditTestMatchWithImagesRow
          key={item.id}
          item={item}
          onChangeRow={onChangeRow}
          onDelete={onDeleteRow}
        />
      ))}
      {_.size(test.matching) < MAX_ROWS && (
        <Button colorScheme='blue' onClick={handleAddRow}>
          Add Row
        </Button>
      )}
    </VStack>
  )
}

export default EditTestMatchWithImages
